import axios from 'axios'
import {
  Request2FACodeParams,
  Validate2FACodeParams,
} from '../interface/two-factor-auth'

/**
 * Request a 2fa code be sent to a guest phone number for a business
 * 204 - two factor code sent to user
 * 404 - not found, no guest found for the business
 * 422 - validation errors, incorrect payload
 * 500 - internal server error
 */

export const request2FACode = async ({
  authValue,
  authType,
  businessId,
}: Request2FACodeParams): Promise<number> => {
  return axios
    .post('v2/two-factor/request-code', {
      authValue,
      authType,
      businessId,
    })
    .then((res) => res.status) // may want to return data at some point
}

/**
 * Validate a 2fa code entered by a user
 * 200 - ok, code validated
 * 401 - unauthorized, code not validated
 * 422 - validation errors, incorrect payload
 * 500 - internal server error
 */

export const validate2FACode = async ({
  authValue,
  authCode,
}: Validate2FACodeParams): Promise<number> => {

  try {
    const status = await axios
    .post('v2/two-factor/validate-code', {
      authValue,
      authCode,
    })
    .then((res) => res.status) // may want to return data at some point
    return status
  } catch (error) {
    console.error(error)
    return error?.response?.status
  }
}
